import { z } from 'zod';

export const WealthManagerClientTypeValues = ['wm_personal', 'wm_business'] as const;

export const ZodWealthManagerClientType = z.enum(WealthManagerClientTypeValues);

export type WealthManagerClientType = z.infer<typeof ZodWealthManagerClientType>;
